import React from 'react';
import './Button.scss';

function Button({ children, onClick, className = '', disabled = false, active = false }) {
    return (
        <button 
            className={`custom-button ${className} ${disabled ? 'disabled' : ''} ${active ? 'active' : ''}`} 
            onClick={onClick}
            disabled={disabled}
        >
            <span className="button-text">{children}</span>
        </button>
    );
}

export default Button;
